export default class CallAnnotationService {
  /** @ngInject **/
  constructor(
    $http,
    ngAuthSettings,
    userSettingsService
  ) {
    this.$http = $http;
    this.ngAuthSettings = ngAuthSettings;
    this.userSettingsService = userSettingsService;

    this.serviceBaseUri = ngAuthSettings.apiServiceBaseUri;
  }

  annotateCall(accountId, callId, tag) {
    if (!tag.type) {
      tag.type = 'Annotations';
    }

    var data = {
      inboundCallId: callId,
      tags: [{
        tagName: tag.name,
        tagType: tag.type,
        tagValue: tag.value
      }]
    };
    
    var url = this.serviceBaseUri + accountId + '/calls/annotate';

    return this.$http.post(url, data).then(() => {
      return this._addTagToSettings(tag);
    });
  }

  getRecentTags() {
    return this.userSettingsService.getUserSettings().then(function (setting) {
      return setting.callTags || [];
    });
  }

  _addTagToSettings(tag) {
    tag.key = tag.type+':'+tag.name+':'+tag.value;
    return this.userSettingsService.getUserSettings().then((setting) => {
      setting.callTags = setting.callTags || {};
      setting.callTags[tag.key] = tag;

      return this.userSettingsService.saveUserSettings(setting);
    });
  }
}